import Meta from "../../../components/common/Meta";
import React, {useEffect} from "react";
import Footer from "../../../components/common/Footer";
import ErrorContent from "../../../components/common/error/ErrorContent";
import UserHeader from "../../../components/user/UserHeader";
import MainDesign from "../../MainDesign";
import {TraceService} from "../../../service/TraceService";
import {TraceType} from "../../../model/user/general/Trace";
import {v4 as uuidv4} from "uuid";
import EnProdukacjaCopyrightNote from "../../../components/funnel/EnProdukacjaCopyrightNote";

export default function Error404() {
    const isEn = window.location.pathname.startsWith('/en/') || window.location.pathname.startsWith('/en');

    useEffect(() => {
        const sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
            localStorage.setItem('sessionId', uuidv4());
        }
        TraceService.addTrace(TraceType.ErrorPage, undefined);
    }, []);

    if (isEn) {
        return <>
            <Meta title='Page not found' noIndex={true}/>
            <MainDesign containerStyles="container py-16" useGradientBackground={true} minHeight="100vh">
                <ErrorContent messageProps="Page not found."/>
                <EnProdukacjaCopyrightNote/>
            </MainDesign>
        </>
    }

    return <>
        <Meta title='Produkacja OS - Środowisko do nauki, planowania i działania' noIndex={true}/>
        <UserHeader/>
        <MainDesign containerStyles="container py-16" useGradientBackground={true}>
            <ErrorContent messageProps="Strona nie została znaleziona."/>
        </MainDesign>
        <Footer/>
    </>
}